import { removeHtmlTag } from '@exam-management/common/utils';
import { Flex, PaperSection, ReadonlyField, Text } from '@shared/components';

import { QuestionCreationCountSummary } from '../../components';
import { useQuestionCreationTaskDetails } from '../../providers';
import { TaskContentPreviewer } from '../task-content-previewer';
export default function QuestionCreationTaskQuestionDetails() {
  const { task } = useQuestionCreationTaskDetails();

  const requirement = task.metadata?.requirement;
  const itemSetCondition = requirement?.itemSetCondition ?? [];
  const singleQuestionCount = requirement?.requiredQuestionCount ?? 0;

  return (
    <PaperSection title='Question Details'>
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(4),
          p: theme.spacing(6),
        })}
      >
        <ReadonlyField label='คลังข้อสอบ' content={requirement?.qBankStructure?.name ?? '-'} />
        <ReadonlyField
          label='รายละเอียดคำถามที่ต้องการ'
          content={
            <TaskContentPreviewer
              taskId={task.id}
              content={
                requirement?.details && removeHtmlTag(requirement?.details, { customTag: 'p' })
                  ? requirement?.details
                  : '-'
              }
            />
          }
        />
        <Flex
          sx={(theme) => ({
            flexDirection: 'column',
            gap: theme.spacing(2),
          })}
        >
          <Text variant='body1Semibold'>จำนวนคำถามที่ต้องการ</Text>
          {/*TODO: Implement add item set question once api is added item set creation */}
          <QuestionCreationCountSummary
            singleQuestionCount={singleQuestionCount}
            itemSetQuestion={itemSetCondition.map((condition) => ({
              questionInItemSet: condition.size,
              itemSetCount: condition.needTotal,
            }))}
          />
        </Flex>
      </Flex>
    </PaperSection>
  );
}
